import { render, staticRenderFns } from "./MilkCultures.vue?vue&type=template&id=7d45f0cc&"
import script from "./MilkCultures.vue?vue&type=script&lang=js&"
export * from "./MilkCultures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports